import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenDashboardService, CoordinatorAssignmentItem } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const useCoordinatorAssignments = () => {
    const [assignments, setAssignments] = useState<CoordinatorAssignmentItem[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchCoordinatorAssignments = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<CoordinatorAssignmentItem[]> =
                AspenDashboardService.getCoordinatorAssignmentsDashboardCoordinatorAssignmentsGet()
            const data = await response
            setAssignments(data)
        } catch (err) {
            setError('Failed to fetch coordinator assignments')
            enqueueSnackbar('Failed to fetch coordinator assignments', {
                variant: 'error'
            })
        } finally {
            setLoading(false)
        }
    }, [enqueueSnackbar])

    useEffect(() => {
        fetchCoordinatorAssignments()
    }, [fetchCoordinatorAssignments])

    return { assignments, loading, error, fetchCoordinatorAssignments }
}
